import { RichText } from '@/components/shared/rich-text'
import { SectionHeader } from '@/components/shared/section-header'
import { StoryblokImage } from '@/components/shared/storyblok-image'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { BlokProps } from '@/lib/types'
import { TestimonialsStoryblok } from '@/lib/types/component-types-sb'
import { storyblokEditable } from '@storyblok/react/rsc'
import { Suspense } from 'react'
import { Container } from '../shared/container'

export function Testimonials({ blok }: BlokProps<TestimonialsStoryblok>) {
  return (
    <section
      {...storyblokEditable(blok)}
      className="border-border border-y"
    >
      <div className="border-border border-b pt-20 pb-16">
        <div className="page-container">
          <SectionHeader
            icon={blok.descriptorIcon}
            title={blok.title}
            preTitle={blok.descriptorTitle}
          ></SectionHeader>
        </div>
      </div>
      <Container className="border-border border-x">
        <div className="bg-border grid grid-cols-1 gap-[1px] lg:grid-cols-3">
          {blok.items?.map((item) => (
            <div
              {...storyblokEditable(item)}
              key={item._uid}
              className="bg-background flex flex-col items-start space-y-6 p-6 lg:px-9 lg:py-16"
            >
              {item.logo?.filename && (
                <StoryblokImage
                  image={item.logo}
                  cropWidth={300}
                  className="h-6 w-auto brightness-0 filter dark:brightness-0 dark:invert dark:filter"
                  alt={item.company ?? ''}
                />
              )}
              <div className="grow-1">
                <RichText content={item.content} />
              </div>
              <div className="flex items-center gap-2.5">
                <Avatar>
                  <Suspense
                    fallback={
                      <AvatarFallback>
                        {item.name
                          ?.split(' ')
                          ?.map((p) => p.substring(0, 1))
                          .join('')}
                      </AvatarFallback>
                    }
                  >
                    <StoryblokImage
                      cropHeight={80}
                      cropWidth={80}
                      className="object-cover object-center"
                      image={item.avatar}
                      alt={`${item.name} from ${item.company}`}
                    />
                  </Suspense>
                </Avatar>
                <div>
                  <div className="text-accent-foreground font-medium">{item.name}</div>
                  <div className="text-muted-foreground">
                    {item.role}, {item.company}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
